<ion-button *ngIf="attemps <= maxAttemps" class="ion-no-margin"
  expand="block"
  fill="clear"
  size="small"
  [disabled]="disabled || remainingTime > 0"
  (click)="requireAction()">
  {{ remainingTime > 0 ? (waitingText | translate: ({seconds: remainingTime})) : (readyText | translate)}}
</ion-button>

<p *ngIf="attemps > maxAttemps">
  <ion-text color="warning">{{ 'wrn.max_attempts_reached' | translate }}</ion-text>
</p>